import PropTypes from "prop-types";
import { Copy, Ellipsis, Pencil, Trash2 } from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import ACL_RELATIONSHIPS from "acl-relationships";
import useAuthorized from "hooks/useAuthorized";

export function RolesTableActions({ original, onEdit, onClone, onDelete }) {
  const canEdit = useAuthorized([ACL_RELATIONSHIPS.adminRole.edit]);
  const canDelete = useAuthorized([ACL_RELATIONSHIPS.adminRole.delete]);
  const canClone = useAuthorized([ACL_RELATIONSHIPS.adminRole.create]);

  if (!canEdit && !canDelete && !canClone) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label="Role actions"
        className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
      >
        <Ellipsis />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="tw:w-auto">
        {canEdit && (
          <DropdownMenuItem onClick={() => onEdit(original)}>
            <Pencil />
            Edit
          </DropdownMenuItem>
        )}
        {canDelete && (
          <DropdownMenuItem
            variant="destructive"
            onClick={() => onDelete(original)}
          >
            <Trash2 />
            Delete
          </DropdownMenuItem>
        )}
        {canClone && (
          <DropdownMenuItem onClick={() => onClone(original)}>
            <Copy />
            Clone
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

RolesTableActions.propTypes = {
  original: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onClone: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
